
import { mapActions } from 'vuex';
import InvoicesComponent from '../InvoicesComponent.vue';
import STATE_STATUSES from '../../store/state-statuses';

export default {
  components: { InvoicesComponent },

  props: {
    status: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      STATE_STATUSES,
    };
  },

  methods: {
    ...mapActions('Order', ['triggerIsMainOrderClosed']),
  },
};
